export enum LoadTypeDirections {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
}
